import appConfig from '@/appConfig.json';

const getConfig = () => appConfig;

export default getConfig;
